import {Company} from "../models/company.model";
import {Invoice} from "../models/invoice.model";
import {InvoiceOption} from "../models/item.model";
import {calculateInvoiceSummary} from "./calculate-invoice-summary.util";

export const getVariantCardPrice = (company: Company, invoice: Invoice, option: InvoiceOption): string => {
    const summary = calculateInvoiceSummary(company, invoice, false, option, []);
    return summary?.total ?? option.total;
};
